export const MOBILE_55_VIDEO_ID = 'ow278lli41';
export const DESKTOP_VIDEO_ID = 'pe9z8gpr2y';
export const APP_DOWNLOAD_LINK_APP_PAGE = 'https://goat.app.link/VqCX9RvpVbb';
export const BG_IMG_LG = 'https://cms-cdn.goat.com/3000/b03d95b98315-c979-ee11-9d17-0919d31f.jpg';
export const HERO_IMG_LG = 'https://cms-cdn.goat.com/3000/b96d756d4a16-083a-ee11-ad17-0799a834.jpg';
export const HERO_IMG_SM = 'https://cms-cdn.goat.com/3000/9e2252504173-025a-ee11-ad17-0b47eb85.jpg';
export const QR_CODE = 'https://cms-cdn.goat.com/b828f3d8e61d-e49a-de11-10f5-06c1b8d0.png';
